import { ReportDataInputSchema } from "@redotech/redo-model/fulfillments/shipped-items-report-data";
import * as z from "zod";

export const getShippedItemsReportData = {
  name: "getShippedItemsReportData" as const,
  input: ReportDataInputSchema,
  output: z.object({ shippedItemsReportData: z.array(z.array(z.string())) }),
};
